//add initial analytics data for customer details
import {
  ACCOUNT_DETAILS,
  BUSINESS_CURRENT_ACCOUNT,
  CASE_ID,
  OFFER_CASE_ID,
  LIMITED_COMPANY_ONE_DIRECTOR,
  SOLE_TRADER,
  PRIMARY,
  SECONDARY
} from './constants';
import { getQueryStringValueByName } from './';

/*
need to remove the leading "/" from the page name
for example "/initialQuestions" should become "initialQuestions"
*/

const cleanPageName = pageName => (pageName.charAt(0) === '/' ? pageName.substr(1) : pageName);

const TYPE_SOLE = 'sole';
const TYPE_MULTY = 'multi-party';

export const initialize = ({
  brandName = '',
  pageName = '',
  eligibleSections = [],
  caseId = ''
} = {}) => {
  if (!window._dataLayer) {
    window._dataLayer = {
      appInfo: {
        applicationType: ACCOUNT_DETAILS,
        brandName: brandName,
        caseId: caseId,
        customerNumber: '',
        relationship: '',
        businessJourneyType: '',
        applicant: '',
        pageName: cleanPageName(pageName),
        productName: BUSINESS_CURRENT_ACCOUNT,
        errors: {
          errorCode: '',
          errorMessage: ''
        }
      },
      eligibleSections: eligibleSections,
      updateSections: [],
      sourceAppUrl: document.referrer
    };
  }
};

const getDataLayer = () => {
  if (!window._dataLayer) {
    initialize();
  }
  return window._dataLayer;
};

export const getAdobeBusinessType = businessType =>
  businessType.toLowerCase() === LIMITED_COMPANY_ONE_DIRECTOR.toLowerCase() ||
  businessType.toLowerCase() === SOLE_TRADER.toLowerCase()
    ? TYPE_SOLE
    : TYPE_MULTY;

export const updateBrandName = brandName => {
  getDataLayer().appInfo.brandName = brandName;
};

export const updatePageName = pageName => {
  getDataLayer().appInfo.pageName = cleanPageName(pageName);
};

export const updateApplicant = linkcode => {
  getDataLayer().appInfo.applicant = linkcode ? SECONDARY : PRIMARY;
};

export const updateBusinessType = businessType => {
  getDataLayer().appInfo.businessJourneyType = getAdobeBusinessType(businessType);
};

export const updateCustomer = customer => {
  getDataLayer().appInfo.customerNumber = customer ? customer.customerNumber : '';
  getDataLayer().appInfo.relationship = customer ? customer.relationship : '';
};

export const updateCase = caseDetails => {
  let caseID = caseDetails ? caseDetails[CASE_ID] : '';
  caseID = caseID || getQueryStringValueByName(CASE_ID) || getQueryStringValueByName(OFFER_CASE_ID);
  getDataLayer().appInfo.caseId = caseID;
};

export const error = ({ errorCode, errorMessage }) => {
  getDataLayer().appInfo.errors = { errorCode, errorMessage };
};
